import { h, Component } from 'preact';
import Link from 'components/bolt/link/link';
import { sortObjectByOrder, joinClasses } from 'utils/utils';
import Button from 'components/bolt/button/NTLiveButton';
import s from 'components/bolt/footer/NTLiveFooter.sss';
import Store from 'store/store';

export default class NTLiveFooter extends Component {
	renderStudioLogo(studioLogo) {
		const { src, alt, ariaLabel, href, pageID, title, target } = studioLogo;

		return (
			<Link
				class={s.studioLogo}
				href={href}
				pageId={pageID}
				onClick={e => pageID && Store.emit('CLOSE_AND_NAVIGATE', pageID, e)}
				ariaLabel={ariaLabel}
				title={title}
				target={target}
			>
				<img class={s.image} src={src} alt={alt} />
			</Link>
		);
	}

	renderSponsors(data) {
		const sponsors = sortObjectByOrder(data);

		return (
			<ul class={s.sponsors}>
				{sponsors.map(logo => {
					const { src, alt, ariaLabel, href, pageId, title, id, target } = logo;

					return (
						<li class={joinClasses(s.sponsor, s[id])}>
							<Link
								class={joinClasses(s.logo, s[id])}
								renderCustomChild
								href={href}
								pageId={pageId}
								title={title}
								ariaLabel={ariaLabel}
								target={target}
								rel='noopener'
								onClick={() => Store.emit('POWSTER_GA_EVENT_TRACK', 'partner-click', 'navigation', id)}
							>
								<img class={s.image} src={src} alt={alt} />
							</Link>
						</li>
					);
				})}
			</ul>
		);
	}

	renderLinks(data) {
		const links = sortObjectByOrder(data);

		const firstGroup = links.slice(0, 4);
		const secondGroup = links.slice(4);

		return (
			<ul class={s.links}>
				{[firstGroup, secondGroup].map(group => {
					return <li class={s.list}>
						{group.map(link => {
							const data = { ...link, type: 'footer' };
							let onClick = () => Store.emit('POWSTER_GA_EVENT_TRACK', 'footer-click', 'navigation', data.label);

							return <Button client={this.props.client} extraClass={joinClasses(s.item)} onClick={onClick} data={data} />;
						})}
					</li>;
				})}
			</ul>
		);

	}

	renderSocials(data) {
		const socials = sortObjectByOrder(data);

		return (
			<ul class={s.socials}>
				{socials.map(item => {
					const { icon, href, alt, title, ariaLabel, type } = item;

					return <li class={s.social}>
						<Link
							href={href}
							title={title}
							ariaLabel={ariaLabel}
							target='_blank'
							rel='noopener'
							onClick={() => Store.emit('POWSTER_GA_EVENT_TRACK', 'follow', 'social', type)}
						>
							<img class={s.icon} src={icon} alt={alt} />
						</Link>
					</li>;
				})}
			</ul>
		);
	}

	renderCopyright(copyrights) {
		return <div class={s.copyrights}>
			<p class={s.copyright}>{copyrights.nationalTheatre}</p>
			<Link
				href="https://www.powster.com"
				target="_blank"
				class={joinClasses(s.copyright, s.powster)}
			>
				{copyrights.powster}
			</Link>
		</div>;
	}

	render({ data, showtimes }) {
		const {
			studioLogo  = {},
			sponsors    = {},
			links       = {},
			copyrights  = {},
			socials     = {}
		} = data;

		return (
			<footer class={s.wrapper}>
				<div class={joinClasses(s.container, showtimes && s.showtimes)}>
					<div class={s.logos}>
						{this.renderStudioLogo(studioLogo)}
						{this.renderSponsors(sponsors)}
					</div>
					<div>
						{this.renderLinks(links)}
						{this.renderSocials(socials)}
					</div>
					{this.renderCopyright(copyrights)}
				</div>
			</footer>
		);
	}
}
